import './Sedan.css'
import sedan from '../../images/download.png'
import sedan1 from '../../images/h1am.jpg'
import sedan2 from '../../images/h1da.jpg'
import sedan3 from '../../images/h1da2.jpg'
import { useState } from 'react'
import { IoIosArrowForward } from "react-icons/io";
import { IoIosArrowBack } from "react-icons/io";
import { useRecoilState } from 'recoil'

import { IoIosCloseCircleOutline } from "react-icons/io";
import photoFourState from '../atoms/PhotoFour.atom'



function Sedan() {


    const [show,setShow]=useRecoilState(photoFourState)
  const [currentIndex, setCurrentIndex] = useState(0);

  const images = [
    sedan,
    sedan1,
    sedan2,
    sedan3,
  ];

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };
  return (
    <div className='layout'>
        <div className="containers">
            <IoIosCloseCircleOutline className='close' onClick={()=>{setShow(false)}}/>

               <div className="slider">
      <button onClick={prevSlide} className="slider-button pre"><IoIosArrowBack /></button>
      <img src={images[currentIndex]} alt={`Slide ${currentIndex + 1}`} className="slider-image" />
      <button onClick={nextSlide} className="slider-button next"><IoIosArrowForward /></button>
    </div>
        </div>
    </div>
  )
}

export default Sedan;